import { Backdrop, Box, IconButton, Typography } from "@mui/material";
import React from "react";
import { PropsWithChildren } from "react";
import { useNavigate } from "react-router-dom";
import { Close } from "@mui/icons-material";

export const DetailsBasePage = (
  props: PropsWithChildren<{ title: string }>
) => {
  const { title } = props;
  const navigate = useNavigate();

  const handleClose = () => {
    navigate("/");
  };

  return (
    <Backdrop
      open={true}
      sx={(theme) => ({
        backgroundColor: `${theme.palette.background.default}01`,
        backdropFilter: "blur(16px)",
        zIndex: 1000,
        width: "100vw",
        height: "100vh",
        overflow: "scroll",
        alignItems: "flex-start",
      })}
      onClick={handleClose}
    >
      <Box
        // Prevent click events from propagating to the backdrop
        onClick={(e) => {
          e.stopPropagation();
        }}
        sx={(theme) => ({
          padding: 8,
          paddingTop: 2,

          [theme.breakpoints.down("md")]: {
            padding: 2,
            width: "80vw",
          },

          width: "60vw",
          maxWidth: 1000,
          position: "relative",
        })}
      >
        <Box
          sx={{
            position: "sticky",
            top: 16,
            width: "100%",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <IconButton color="primary" size="large" onClick={handleClose}>
            <Close />
          </IconButton>
        </Box>

        <Typography variant="h3" mb={3}>
          {title}
        </Typography>
        {props.children}
      </Box>
    </Backdrop>
  );
};
